import React from 'react';

function DownArrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.091 7.333 8 6 9.454 12 16l6-6.546L16.667 8 12 13.091z"
        fill="currentColor"
      />
    </svg>
  );
}

export default DownArrow;
